import Theme from '../theme';

import AOS from 'aos';
import smoothscroll from 'smoothscroll-polyfill';

export default {
  init() {
    this.initSlick();
    this.initMenu();
    this.initForm();
    Theme.initVue();
    this.initSubMenu();
    this.headerScroll();
    this.video();
    this.soundToggle();
    this.initLazyLoad();
    this.initAnimation();
    this.smoothScroll();
    this.initSmoothScrollPolyfill();
    this.heroVideoMobileSupport();
    this.backToTop();
  },
  initMenu() {
    const $header = $('header');
    const $hamburger = $('.hamburger');
    const $body = $('body');
    if ($hamburger.length && $header.length) {
      $hamburger.on('click', function() {
        if (!$header.hasClass('menu-open')) {
          $header.addClass('menu-open');
          $body.addClass('menu-open');
        } else {
          $header.removeClass('menu-open');
          $body.removeClass('menu-open');
        }
      });
    }
  },
  initSubMenu() {
    const $subMenu = $('.sub-menu');
    $subMenu.addClass('hidden');
    $(document).on('click', (e) => {
      const $trigger = $('.menu-item');

      if ($trigger !== e.target && !$trigger.has(e.target).length && $subMenu.is(':visible')) {
        $subMenu.addClass('hidden');
      }
    });

    if ($('.menu-item-has-children')) {
      $('.menu-item-has-children > a').on('click', (e) => {
        e.preventDefault();
        $(e.currentTarget).parent().find('.sub-menu').toggleClass('hidden');
      });
    }
  },
  headerScroll: function() {
    $(window).on('scroll', function () {
      let scrollTop = $(window).scrollTop();
      const $header = $('body');
      if (scrollTop > 0) {
        $header.addClass('scrolled');
      } else {
        $header.removeClass('scrolled');
      }
    });
  },
  initForm() {

    function dropdownListener($dropdowns) {
      //Close all dropdowns on outside click
      $('body').on('click', function() {
        $.each($dropdowns, function() {
          closeDropdown($(this));
        });
      });
      $dropdowns.on('click', function(e) {
        e.stopPropagation();
        const wasOpen = $(this).hasClass('open');
        $.each($dropdowns, function() {
          closeDropdown($(this));
        });
        if (!wasOpen) {
          openDropdown($(this));
        }
      });

    }

    function optionsListener($dropdowns) {
      const $options = $dropdowns.find('ul li');
      if ($options.length) {
        $options.on('click', function(e) {
          const $dropdown = $(this).closest('.dropdown');
          e.stopPropagation();
          //uncheck siblings if not multiselect
          if (!$dropdown.hasClass('multiple')) {
            $(this).siblings('li').children('input').prop('checked', false);
            closeDropdown($dropdown);
          }
          //find input and check/uncheck
          const $input = $(this).find('input');
          const checked = $dropdown.hasClass('multiple') ? !$input.is(':checked') : true;
          $input.prop('checked', checked);
          //find checked values and add to textspan
          const $checkedInputs = $dropdown.find('input:checked');
          let values = [];

          $.each($checkedInputs, function() {
            values.push($(this).data('title'));
          });
          const $value = $dropdown.find('span.value');
          let text = values.length >= 4 ? 'Flera val' : values.join(', ');
          $value.html(text);
        });
      }
    }

    function openDropdown($dropdown) {
      const $ul = $dropdown.find('ul');
      if ($ul.length) {
        $ul.slideDown();
        $dropdown.addClass('open');
      }
    }

    function closeDropdown($dropdown) {
      const $ul = $dropdown.find('ul');
      if ($ul.length) {
        $ul.slideUp();
        $dropdown.removeClass('open');
      }
    }

    const $form = $('form');

    if ($form.length) {

      const $dropdowns = $form.find('.dropdown');
      if ($dropdowns.length) {
        dropdownListener($dropdowns);
        optionsListener($dropdowns);
        html_forms.on('success', function(formObject) {
          //clear on success
          $dropdowns.find('span.value').html('');
        });
      }
    }
  },
  initSlick() {
    const $slick = $('.slick:not(.slick_noinit)');
    let params = {
      dots: false,
      // autoplay: true,
    };
    if ($slick.length) {
      Theme.initSlick($slick, params);
    }

    const $slickQuote = $('.quotes.slick');

    params = {
      slidesToShow: 1,
      arrows: true,
      dots: false,
      fade: false,
      autoplay: true,
      autoplaySpeed: 6000,
      swipeToSlide: true,
      infinite: false,
      speed: 400,
      centerMode: true,
      centerPadding: '0',
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          }
        },
      ]
    }
    if($slickQuote.length){
      Theme.initSlick($slickQuote, params);
    }
  },
  video() {
    const playButton = document.querySelector('.video-play');
    const video = document.querySelector('.acf-component-inner.video video');

    if (playButton) {
      playButton.addEventListener('click', () => {
        video.play();
        if(playButton.classList.contains('play')) {
          playButton.classList.remove('play');
          video.pause();
        } else {
          playButton.classList.add('play');
          video.play();
        }
      });
    }
  },
  soundToggle() {
    const soundToggle = document.querySelector('.sound-on');
    const video = document.querySelector('.hero .slide video');
    if (soundToggle) {
      soundToggle.addEventListener('click', e => {
        if (e.target.classList.contains('soundToggle')) {
          e.target.classList.remove('soundToggle');
          video.muted = true;
        } else {
          e.target.classList.add('soundToggle');
          video.muted = false;
        }
      })
    }
  },
  initLazyLoad: function() {
    const me = this;
    const images = document.querySelectorAll('.lazy-image');
    if (!images.length) {
      return;
    }

    const config = {
      rootMargin: '-50px 0px -50px 0px', // determines when the observer has the element in "viewport"
      threshold: 0,
    };

    const observer = new IntersectionObserver(function(entries, self) {
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          me.preloadImage(entry.target);
          entry.target.addEventListener('load', function(entry){
            entry.target.classList.add('loaded');
          });
          //stop watching
          self.unobserve(entry.target);
        }
      });
    }, config);
    images.forEach(function(image) {
      observer.observe(image);
    });
  },
  preloadImage: function(img) {
    const src = img.getAttribute('data-src');
    if (!src) {
      return;
    }
    img.src = src;

    const srcSet = img.getAttribute('data-srcset');
    if (!srcSet) {
      return;
    }
    img.srcset = srcSet;
  },
  initAnimation: function() {
    AOS.init();
  },
  getOffsetTop: function(element) {
    let offsetTop = 0;
    while(element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  },
  initSmoothScrollPolyfill: function() {
    smoothscroll.polyfill();
  },
  smoothScroll() {
    // Adding smooth scroll to anchor links.
    const self = this;

    document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const element = document.querySelector(this.getAttribute('href'));
        const main = document.querySelector('main');
        const header = document.querySelector('header');
        const elementOffset = self.getOffsetTop(element);
        const headerHeight = header.offsetHeight;

        let offsetPosition = elementOffset - main.scrollTop - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      });
    });
  },
  heroVideoMobileSupport: function() {
    const $videoElement = $('.hero .video video');
    const $videoWrapper = $('.hero .video');
    let video = null;
    if ($videoElement.length) {
      video = $videoElement[0];

      const $sourceElement = $videoElement.find('source');
      $sourceElement.prop('src', $sourceElement.data('src'));

      if ($(window).width() < 768) {
        if ($($videoElement.find('source').eq(1))) {
          const $sourceElementMobile = $($videoElement.find('source').eq(1));
          $sourceElement.prop('src', $sourceElementMobile.data('src'));
        }
      }

      if (!$videoWrapper.hasClass('loaded')) {
        video.load();
        $videoWrapper.addClass('loaded');
      }
    }
  },
  backToTop: function() {
    const showButtonOn = 500;
    const backToTopButton = document.querySelector('.back-to-top');
    const backToTopWrapper = document.querySelector('.back-to-top-wrapper');

    const scrollContainer = () => {
      return document.documentElement || document.body;
    };

    if (backToTopButton) {
      document.addEventListener('scroll', () => {
        if (scrollContainer().scrollTop > showButtonOn) {
          backToTopWrapper.classList.remove('hidden');
        } else {
          backToTopWrapper.classList.add('hidden');
        }
      })

      backToTopButton.addEventListener('click', () => {
        document.body.scrollIntoView();
      })
    }
  },
};
